/* @ngInject */
const saleFormat = (
  utils,
  valueHandler,
  $$axletree,
  $$piece,
  $$sterile
) => {
  const self = {}

  self.server = (_sale) => {
    if (valueHandler.isEmpty(_sale)) {
      return null
    }
    const sale = utils.copy(_sale)

    if (sale.date) {
      sale.date = utils.date.stringToServer(sale.date)
    }
    if (sale.dateBegin) {
      sale.dateBegin = utils.date.stringToServer(sale.dateBegin)
    }
    if (sale.dateEnd) {
      sale.dateEnd = utils.date.stringToServer(sale.dateEnd)
    }

    if (sale.axletrees) {
      sale.axletrees = $$axletree.format.server(sale.axletrees)
    }
    if (sale.pieces) {
      sale.pieces = $$piece.format.server(sale.pieces)
    }
    if (sale.steriles) {
      sale.steriles = $$sterile.format.server(sale.steriles)
    }

    return sale
  }

  self.user = (_sale) => {
    if (valueHandler.isEmpty(_sale)) {
      return null
    }
    const sale = utils.copy(_sale)

    if (sale.date) {
      sale.date = utils.date.timestampToString(sale.date)
    }
    if (sale.dateBegin) {
      sale.dateBegin = utils.date.timestampToString(sale.dateBegin)
    }
    if (sale.dateEnd) {
      sale.dateEnd = utils.date.timestampToString(sale.dateEnd)
    }

    if (sale.axletrees) {
      sale.axletrees = $$axletree.format.user(sale.axletrees)
    }
    if (sale.pieces) {
      sale.pieces = $$piece.format.user(sale.pieces)
    }
    if (sale.steriles) {
      sale.steriles = $$sterile.format.user(sale.steriles)
    }

    return sale
  }

  return self
}
export default saleFormat



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/format.service.js